export default __webpack_public_path__ + "static/media/books.83c1cff6.png";